import React, {
  useEffect,
  useState,
  useImperativeHandle,
  forwardRef,
} from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { useIntl } from 'react-intl';
import { Input, Tooltip, Checkbox, Row } from 'antd';

import SearchFilterRadio from './SearchFilterRadio';

import * as globalSelectors from '@redux/global/selectors';
import selectorsGridView from 'common/components/grid-view/controllers/selectors';
import * as actionsGridView from 'common/components/grid-view/controllers/actions';

import {
  checkSearchAssetForMember,
  pathnameAssetForMember,
  useDefaultSearchText,
  checkPathNameHasPrimaryFieldsOnly,
  checkPathNameProductRadioFilter,
} from 'pages/home/utils';

const { Search } = Input;

const SearchInput = (props, ref) => {
  const dispatch = useDispatch();
  const intl = useIntl();

  const { searchCriteria, handleSearch } = props;

  const pathname = window.location.pathname;

  const [searchText, setSearchText] = useState('');
  const [primaryFieldsOnly, setPrimaryFieldsOnly] = useState(true);

  const { getDefaultSearchText, getDefaultPrimaryFieldsOnly } =
    useDefaultSearchText();

  const { toggleRefreshQuery } = useSelector(
    selectorsGridView.makeSelectGridConfig()
  );

  const isSearchAssetForMember = checkSearchAssetForMember(pathname);
  const isPrimaryFieldsOnly = checkPathNameHasPrimaryFieldsOnly(pathname);
  const isProductRadioFilter = checkPathNameProductRadioFilter(pathname);

  let searchString = '';

  if (isSearchAssetForMember) {
    searchString = getDefaultSearchText(pathnameAssetForMember);
  } else {
    searchString = getDefaultSearchText(pathname);
  }

  useEffect(() => {
    // display searchText when choose grid-query
    setSearchText(searchString);

    const primaryFieldsOnly = getDefaultPrimaryFieldsOnly(pathname);
    setPrimaryFieldsOnly(primaryFieldsOnly);

    if (toggleRefreshQuery) {
      dispatch(actionsGridView.toggleRefreshQuery(false));
    }
  }, [dispatch, searchString, toggleRefreshQuery]);

  useImperativeHandle(ref, () => ({
    clearSearchText: () => {
      setSearchText('');
    },
  }));

  return (
    <Row style={{ alignItems: 'center', width: '100%' }}>
      <Search
        placeholder={intl.formatMessage(
          {
            id: 'Taco.home.components.layout.search.placeholder',
          },
          {
            entity: searchCriteria,
          }
        )}
        bordered={true}
        value={searchText}
        onChange={(e) => setSearchText(e.target.value)}
        onSearch={() => handleSearch(searchText, primaryFieldsOnly)}
        style={{ flex: 1 }}
        id='search-input'
        autoComplete='off'
        suffix={
          isPrimaryFieldsOnly && (
            <Tooltip
              placement='left'
              title='Only search on commonly used fields, this will make the search faster and more accurate. Turning off this checkbox will search on most fields of the entity.'
            >
              <Checkbox
                checked={primaryFieldsOnly}
                onChange={(e) => setPrimaryFieldsOnly(e.target.checked)}
              />
            </Tooltip>
          )
        }
      />
      {isProductRadioFilter && (
        <Row style={{ marginLeft: 4 }}>
          <SearchFilterRadio />
        </Row>
      )}
    </Row>
  );
};

export default forwardRef(SearchInput);
